import { client } from "../client";

export const getChat = (userId) => {
  return client
    .get("chat?userId=" + userId)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getAllChats = () => {
  return client
    .get("chat")
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getUnreadCounts = () => {
  return client
    .get("chat/unread")
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const makeAsRead = (chatId) => {
  return client
    .put("chat/read", { chatId })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getMessages = (chatId) => {
  return client
    .get("chat/" + chatId)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const sendMessage = (chatId, body) => {
  return client
    .post("chat/" + chatId, body)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const sendMessageWithMedia = (chatId, { message = "", file }) => {
  const form = new FormData();
  form.append("message", message);
  if (file) form.append("media", file); // field name must be "media" for .single("media") on backend

  // IMPORTANT: do NOT set Content-Type manually
  return client
    .post("chat/" + chatId, form)
    .then((result) => result)
    .catch((err) => err.response);
};

export const getChatById = (chatId) => {
  return client
    .get(`chat/details/${chatId}`)
    .then((result) => result)
    .catch((err) => err.response);
};

export const deleteChat = (chatId) => {
  return client
    .delete("chat/" + chatId)
    .then((result) => result)
    .catch((err) => err.response);
};
